export enum StatusArquivo {
    GERADO=1,
    TRANSMITIDO=2,
    ACEITO=3,
    REJEITADO=4,
    CANCELADO=5
  }


// WEBPACK FOOTER //
// ./src/app/shared/enum/StatusArquivo.ts